import UpdateAvailable from './update-available';

export * from './update-available';

export default UpdateAvailable;
